import * as React from "react";
const SvgMinusWhite = (props) => /* @__PURE__ */ React.createElement("svg", { width: 15, height: 15, viewBox: "0 0 15 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 6H15V8.14286H0V6Z", fill: "white" }));
export default SvgMinusWhite;
